import React from 'react'
import Typography from '@material-ui/core/Typography';

export default function SectionHeader({ label }) {
  return <div style={{}}>
    <Typography variant='h6' style={{ padding: 8, paddingLeft: 16, color: 'white', marginTop: -8, borderRadius: '5px', background: "linear-gradient(90deg, #683fb5, #b87df9)" }}>  {label}    </Typography>
  </div>;
}